"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const ContactUs = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M13.637 5.385a.685.685 0 1 0-.685.687.686.686 0 0 0 .675-.687h.01zm-2.333 0a.687.687 0 1 0-.686.687.686.686 0 0 0 .681-.687h.005zm-2.332 0a.687.687 0 1 0-.687.687h.002a.687.687 0 0 0 .685-.687zm5.45-3.808a5.387 5.387 0 0 1-6.562 8.438l-1.766.513a.5.5 0 0 1-.62-.62l.513-1.766a5.387 5.387 0 0 1 8.435-6.565zM1.732 13.15a7.388 7.388 0 0 1-1.73-4.907 2.457 2.457 0 0 1 1.466-2.191l.18-.079a.9.9 0 0 1 1.078.279L3.94 7.833a.833.833 0 0 1-.073 1.1l-.818.819c.107.662.391 1.283.823 1.796l.045.054c.146.173.306.334.48.48l.053.045a3.717 3.717 0 0 0 1.796.823l.819-.818a.833.833 0 0 1 1.1-.074l1.584 1.214a.9.9 0 0 1 .278 1.078l-.078.18A2.456 2.456 0 0 1 7.757 16h-.154a7.384 7.384 0 0 1-4.752-1.732l-.095-.078a7.75 7.75 0 0 1-.945-.945l-.078-.095z",
  className: "fill"
}));
var _default = exports.default = ContactUs;